import { graphql } from "@/lib/gql/__generated__";

export const PlanI18n_DesignPage_Query = graphql(`
	query PlanI18n_DesignPage($hotelID: ID!, $planID: ID!, $lang: LangCode!) {
		planI18n(hotelID: $hotelID, planID: $planID, lang: $lang) {
			id
			lang
			planID
			name
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
			articleTitle
		}
	}
`);
